import styles from "./chatBotApiTest.module.css";

export const RecentPanel = ({ loading, onSubmit }) => {
  const handleSubmit = (event) => {
    event.preventDefault();
    onSubmit();
  };

  return (
    <form className={styles.form} onSubmit={handleSubmit}>
      <p className={styles.note}>
        Takes no parameters. The account comes from the USER_ID claim on the bearer token, and the response
        carries that id back along with the last 5 orders.
      </p>

      <button type="submit" className={styles.primaryButton} disabled={loading}>
        {loading ? "Sending…" : "Send request"}
      </button>
    </form>
  );
};
